import { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  ChatBlock,
  Container,
  Header,
  TaskChat,
  TaskName,
  GotoIcon,
} from "./styles";
import Chat from "../../../../../../assets/icons/Chat";
import ChatReport from "./ChatReport";

const IterableChatReport = ({ tasks }) => {
  const [expandedTask, setExpandedTask] = useState(null);
  const user = useSelector((state) => state.auth.user);

  const history = useHistory();
  const handleTaskClick = (taskId, TaskStatus) => {
    history.push(`/tasks?taskId=${taskId}&status=${TaskStatus}`);
  };

  const toggleExpand = (taskId) => {
    if (expandedTask === taskId) {
      setExpandedTask(null); // Collapse if the same task is clicked again
    } else {
      setExpandedTask(taskId); // Expand the new task
    }
  };

  return tasks.map((task, index) => (
    <Container onClick={() => toggleExpand(index)} key={"task" + index}>
      <Header>
        <TaskName>{task.taskLabel}</TaskName>
        <TaskName>{task.flowTitle}</TaskName>
        <TaskChat>
          <Chat height="1rem" />
          {task.messages.length}
        </TaskChat>
        <GotoIcon
          taskStatus={task.taskStatus}
          onClick={(e) => {
            e.stopPropagation();
            handleTaskClick(task.taskId, task.taskStatus);
          }}
        />
      </Header>

      {expandedTask === index && (
        <ChatBlock>
          <ChatReport chat={task.messages} user={user} />
        </ChatBlock>
      )}
    </Container>
  ));
};

export default IterableChatReport;
